const hesRetNocturia= [

    {
    label:"Problem:",
    controlType:"checkbox group",
    options:["Hesitancy", "Retention", "Nocturia" ]
    },

    {
    label:"Occurs:",
    controlType:"radio button",
    options:["Every Day", "Most days", "Weekly", "Evey couple of weeks", "Monthly", "Occasionally"]
    },
    
    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days","Weeks","Months","Years"]
    }
    
]

export default hesRetNocturia